import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Search from '../components/Search';

const queryClient = new QueryClient();

const root = createRoot(document.getElementById('reactSearch'));
root.render(
  <QueryClientProvider client={queryClient}>
    <Search />
  </QueryClientProvider>
);
